import { mergeStyleSets } from "@fluentui/react";
export const outcomeSelectionTileStyles = mergeStyleSets({
    fieldset: {
        border: 0,
        margin: 0,
        minWidth: 0,
        padding: 0,
    },
    legend: {
        color: "#323130",
        fontSize: "14px",
        fontWeight: 600,
        padding: 0,
    },
    requiredIndicator: {
        color: "#a4262c",
        paddingLeft: "4px",
    },
    helpText: {
        color: "#605e5c",
        marginBottom: "12px",
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
        gap: "12px",
        width: "100%",
    },
    tile: {
        backgroundColor: "#ffffff",
        border: "1px solid #c8c6c4",
        borderRadius: "6px",
        boxSizing: "border-box",
        cursor: "pointer",
        display: "block",
        minHeight: "176px",
        padding: "20px",
        position: "relative",
        selectors: {
            "&:hover": {
                borderColor: "#0078d4",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
            },
            "&:focus-within": {
                outline: "2px solid #0078d4",
                outlineOffset: "2px",
            },
        },
    },
    selectedTile: {
        backgroundColor: "#eff6fc",
        borderColor: "#0078d4",
        boxShadow: "inset 0 0 0 1px #0078d4",
    },
    disabledTile: {
        backgroundColor: "#f3f2f1",
        cursor: "not-allowed",
        opacity: 0.7,
    },
    checkbox: {
        accentColor: "#0078d4",
        cursor: "pointer",
        height: "18px",
        margin: 0,
        position: "absolute",
        right: "16px",
        top: "16px",
        width: "18px",
    },
    iconContainer: {
        alignItems: "center",
        borderRadius: "50%",
        display: "flex",
        height: "48px",
        justifyContent: "center",
        marginBottom: "14px",
        width: "48px",
    },
    icon: {
        fontSize: "24px",
    },
    blueIcon: {
        backgroundColor: "#deecf9",
        color: "#005a9e",
    },
    purpleIcon: {
        backgroundColor: "#f4ecfb",
        color: "#5c2d91",
    },
    orangeIcon: {
        backgroundColor: "#fdf3e7",
        color: "#a4262c",
    },
    redIcon: {
        backgroundColor: "#fde7e9",
        color: "#a80000",
    },
    tealIcon: {
        backgroundColor: "#e7f5f5",
        color: "#006666",
    },
    greenIcon: {
        backgroundColor: "#dff6dd",
        color: "#0b6a0b",
    },
    grayIcon: {
        backgroundColor: "#edebe9",
        color: "#484644",
    },
    title: {
        color: "#323130",
        display: "block",
        fontSize: "16px",
        fontWeight: 600,
        lineHeight: "22px",
        marginBottom: "6px",
        paddingRight: "22px",
    },
    description: {
        color: "#605e5c",
        display: "block",
        fontSize: "13px",
        lineHeight: "18px",
    },
    otherField: {
        marginTop: "12px",
        maxWidth: "720px",
    },
});
